import { Container } from '@material-ui/core';
import React from 'react';
import { Row } from 'plataforma-fundacao-componentes';

import styles from './styles.module.scss';
import { clsx } from 'helpers/utils/HTMLUtils';

interface Props {
  className?: string;
  header?: React.ReactNode;
  headerClassName?: string;
  children: React.ReactNode;
  contentClassName?: string;
}

export default function PrivateContainer({
  className,
  header,
  headerClassName = '',
  children,
  contentClassName = '',
}: Props) {
  return (
    <Container
      component={'article'}
      className={clsx([styles.root, className!])}
    >
      {header && (
        <Row className={clsx([styles.header, headerClassName])}>{header}</Row>
      )}
      <Row className={clsx([styles.content, contentClassName])}>{children}</Row>
    </Container>
  );
}
